import { ReactNode } from 'react';
import ServicePageTemplate from 'presentations/views/components/templates/ServicePageTemplate';
import StaticContentTemplate from 'presentations/views/components/templates/StaticContentTemplate';

interface Props {
  header: ReactNode;
  breadcrumbs: ReactNode;
  title: string;
  content: string;
}

export default function Component(props: Props) {
  return (
    <ServicePageTemplate header={props.header} breadcrumbs={props.breadcrumbs}>
      <StaticContentTemplate title={props.title} content={props.content} />
    </ServicePageTemplate>
  );
}
